import React, { Component } from 'react'
import axios from 'axios'

import Adresse from './Adresse.jsx'
import ByggList from './ByggList.jsx';
import BruksenhetList from './BruksenhetList.jsx';
import KretsList from './KretsList.jsx';
import MatrikkelenhetList from './MatrikkelenhetList.jsx';
import MatrikkelSearchEvents from '../MatrikkelSearchEvents.js'

class AdresseDetails extends Component {
    state = {
        adresse: null
    }

    UNSAFE_componentWillReceiveProps = (nextProps) => {
        if (this.state.adresse == null) return
        if (nextProps.adresseId == this.state.adresse.adresseId) return

        this.setState({adresse: null})
    }

    componentDidMount = () => {
        this.getAdresse()
    }

    shouldComponentUpdate = (nextProps, nextState) => {
        var currentAdresseId = null;
        if (this.state.adresse != null) currentAdresseId = this.state.adresse.adresseId

        var nextAdresseId = null
        if (nextState.adresse != null) nextAdresseId = nextState.adresse.adresseId

        if (currentAdresseId != nextAdresseId) return true
        return false
    }

    componentDidUpdate = () => {
        if (this.state.adresse == null || this.state.adresse.adresseId != this.props.adresseId) this.getAdresse()
    }

    getAdresse = () => {
        axios.get(`${this.props.settings.baseUrl}api/adresse/${this.props.adresseId}`, {
            params: {
                token: this.props.token
            }
        })
        .then(({data}) => {
            this.setState({adresse: data})
            this.props.onEvent({
                type: MatrikkelSearchEvents.SelectAdresse,
                data: {
                    adresse: data
                }
            })
            this.props.onEvent({
                type: MatrikkelSearchEvents.ZoomToObject,
                data: {
                    type: MatrikkelSearchEvents.ShowAdresse,
                    adresse: data
                }
            })
        })
      }

    render() {
        if (this.state.adresse == null) return (<div className="spinner"><i className="fa fa-spinner fa-spin"></i></div>)
        var adresse = this.state.adresse
        return (
            <ul className="resultdetails">
                <Adresse adresse={adresse} token={this.props.token} settings={this.props.settings} onEvent={this.props.onEvent} />
                { adresse.antallBygg > 0 && <ByggList adresseId={adresse.adresseId} antall={adresse.antallBygg} token={this.props.token} settings={this.props.settings} onEvent={this.props.onEvent} onMatrikkelObjectSelected={this.props.onMatrikkelObjectSelected} /> }
                { adresse.antallBruksenheter > 0 && <BruksenhetList adresseId={adresse.adresseId} antall={adresse.antallBruksenheter} token={this.props.token} settings={this.props.settings} onEvent={this.props.onEvent} /> }
                { adresse.antallKretser > 0 && <KretsList adresseId={adresse.adresseId} antall={adresse.antallKretser} token={this.props.token} settings={this.props.settings} onEvent={this.props.onEvent} /> }
                { adresse.antallMatrikkelenheter > 0 && <MatrikkelenhetList adresseId={adresse.adresseId} antall={adresse.antallMatrikkelenheter} token={this.props.token} settings={this.props.settings} onEvent={this.props.onEvent} onMatrikkelObjectSelected={this.props.onMatrikkelObjectSelected} /> }
            </ul>
        )
    }
}

export default AdresseDetails